module.exports = __webpack_public_path__ + "static/media/thumbs_img_0343.aa47fd96.jpg";